import { FC, useState } from 'react';
import styled from '@emotion/styled';
import { YearsSelect } from './YearsSelect';
import { VoteResultSwitch } from './VoteResultSwitch';
import { SearchBar } from './SearchBar';
import { VoteResultSelectValues } from './types';
import { ISearchOptions } from '../Home';

const StyledSearchArea = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-gap: 16px;
  margin-top: 32px;
  width: 100%;
`;

const StyledFilters = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
`;

interface SearchAreaProps {
  options: ISearchOptions;
  setOptions: (options: any) => void;
  onSubmit: (options: ISearchOptions) => void;
}

export const SearchArea: FC<SearchAreaProps> = ({
  onSubmit,
  options,
  setOptions,
}) => {
  return (
    <StyledSearchArea>
      <StyledFilters>
        <YearsSelect
          value={options.year}
          setValue={(year) => setOptions((prev: any) => ({ ...prev, year }))}
        />
        <VoteResultSwitch
          selectedOption={options.result}
          onRadioButtonChange={(result) =>
            setOptions((prev: any) => ({ ...prev, result }))
          }
        />
      </StyledFilters>
      <SearchBar
        value={options.query}
        setValue={(query) => setOptions((prev: any) => ({ ...prev, query }))}
        onSubmit={() => onSubmit(options)}
      />
    </StyledSearchArea>
  );
};
